import React from 'react';
import styled from 'styled-components';
import { Header } from '@app/navigation/header';
import { ExtraWideBody } from '@ui';
import { AI_TOOLS } from '@constants';
import TableAnalysisTool from '@containers/TableAnalysis/TableAnalysisTool';
import { GRID_MODES } from '@containers/gridMode';

const PageWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
`;

const tool = AI_TOOLS.DOC_GRID_AGENT_GRID_MODE;

function DocGridAgentTableAnalysis() {
  const [docMode] = React.useState(GRID_MODES.docTemplateAgent);

  return (
    <PageWrapper>
      <Header />
      <ExtraWideBody withFooter>
        <TableAnalysisTool docMode={docMode} tool={tool} />
      </ExtraWideBody>
    </PageWrapper>
  );
}

export default DocGridAgentTableAnalysis;
